<template>
  <div>
    <div class="checkbox-container" style="position: relative">
      <label class="el-checkbox">
        <span class="el-checkbox__input" :class="{ 'is-checked': visible }">
          <span class="el-checkbox__inner">
            <img
              class="el-checkbox__img"
              v-show="visible"
              src="https://picbed.qunarzz.com/71b851ba571b8c8bdf6857294b07826b.png"
            />
            <img src="//img.ruiccm.com/2021/FTMS_CK_202107/images/check.png" />
          </span>
          <input
            @change="changeCheckBox"
            type="checkbox"
            aria-hidden="false"
            class="el-checkbox__original"
            value
          />
        </span>
        <span class="el-checkbox__label white">
          已阅读并同意<a @click="showPolicy2">《个人信息授权声明》</a>及<a @click="showPolicy">《隐私政策》</a>。
        </span>
      </label>
    </div>
    <span class="white small"
      >您的个人资料有可能会提交至上汽奥迪厂商的授权经销商或汽车之家客服，与您进一步沟通试驾、购车等事宜。</span
    >
  </div>
</template>
<script>
import policyDialog from "./dialog/policy/index";
import policyDialog2 from "./dialog/policy2/index";
export default {
  props: ["value"],
  data() {
    return {
      visible: true,
    };
  },
  created() {
    this.visible = this.value;
  },
  methods: {
    changeCheckBox() {
      this.visible = !this.visible;
      this.$emit("input", this.visible);
    },
    showPolicy(e) {
      policyDialog();
      e.preventDefault();
    },
    showPolicy2(e) {
      policyDialog2();
      e.preventDefault();
    },
  },
};
</script>
<style lang="less" scoped="true">
.rem(@name,@px) {
  @{name}: unit(@px / 37.5, rem);
}
.checkbox-container {
  display: grid;
  width: 100%;
  margin-top: 15px;
  margin-right: auto;
  grid-template-columns: 50px auto;
  user-select: none;
  * {
    user-select: none;
  }
}
a{
  color:#F50537 !important;
}
.tipBox {
  height: 20px;
  position: relative;
  z-index: 20;
  left: 20px;
  width: 100px;
}
.el-checkbox {
  color: #1c3855;
  font-weight: bold;
  position: relative;
  cursor: pointer;
  display: flex;
  user-select: none;
  text-align: left;

  width: 330px;
  font-size: 10px;
  font-family: Source Han Sans CN;
  font-weight: 300;
  color: #232323;
}
.el-checkbox__input {
  cursor: pointer;
  outline: none;
  display: inline-block;
  top: 0;
  vertical-align: middle;
  left: 3px;
}
.el-checkbox__img {
  width: 20px;
  position: absolute;
  right: 0px;
  bottom: 3px;
}
.el-checkbox__inner {
  display: block;
  position: relative;
  border-radius: 2px;
  width: 20px;
  height: 20px;
  // border:2px solid #8292a2;
  z-index: 1;
  top: -1px;
  right: 5px;
  transition: border-color 0.25s cubic-bezier(0.71, -0.46, 0.29, 1.46),
    background-color 0.25s cubic-bezier(0.71, -0.46, 0.29, 1.46);
}
.el-checkbox__input.is-checked .el-checkbox__inner:after {
  transform: rotate(45deg) scaleY(1);
}
.el-checkbox__original {
  opacity: 0;
  outline: none;
  position: absolute;
  margin: 0;
  width: 0;
  height: 0;
  z-index: -1;
}
.el-checkbox__label {
  display: inline-block;
  line-height: 19px;
  font-size: 10px;
  font-weight: bold;
}
.white {
  color: #fff !important;
}
.small{
  font-size:8px;
  text-align: left;
  display: block;
}
</style>
